export abstract class AbstractHasBufferedUpdates
{
	// frontend-only properties
	public pendingSync: boolean | null = null;

	abstract clone(): this;
}
